import { render, staticRenderFns } from "./addPrinterRuleRepair.vue?vue&type=template&id=b22bd09c"
import script from "./addPrinterRuleRepair.vue?vue&type=script&lang=js"
export * from "./addPrinterRuleRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports